export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    sentUserActivity: async function(_, payload) {
      return this.$api.activity.sentUserActivity(payload);
    }
  }
}
